import { createSelector } from 'reselect';

const selectGlobalRoutingModels = (state: any) => state.globalRoutingModels;


export const selectGlobalRoutingModelsCurrentItem = createSelector([selectGlobalRoutingModels], (globalRoutingModels) => globalRoutingModels.current);

export const selectGlobalRoutingModelsListItems = createSelector([selectGlobalRoutingModels], (globalRoutingModels) => globalRoutingModels.list);

export const selectGlobalRoutingModelsItemById = (itemId: any) =>
    createSelector(selectGlobalRoutingModelsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalRoutingModelsQueryItems = createSelector([selectGlobalRoutingModels], (globalRoutingModels) => globalRoutingModels.query);

export const selectGlobalRoutingModelsCreatedItem = createSelector([selectGlobalRoutingModels], (globalRoutingModels) => globalRoutingModels.create);

export const selectGlobalRoutingModelsUpdatedItem = createSelector([selectGlobalRoutingModels], (globalRoutingModels) => globalRoutingModels.update);

export const selectGlobalRoutingModelsReadItem = createSelector([selectGlobalRoutingModels], (globalRoutingModels) => globalRoutingModels.read);

export const selectGlobalRoutingModelsDeletedItem = createSelector([selectGlobalRoutingModels], (globalRoutingModels) => globalRoutingModels.delete);

export const selectGlobalRoutingModelsSearchedItems = createSelector([selectGlobalRoutingModels], (globalRoutingModels) => globalRoutingModels.search);

export const selectGlobalRoutingModelsItemsCount = createSelector([selectGlobalRoutingModels], (globalRoutingModels) => globalRoutingModels.count);

export const selectGlobalRoutingModelsItemsFilter = createSelector([selectGlobalRoutingModels], (globalRoutingModels) => globalRoutingModels.filter);